import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import './index.css';
import AdminDashboard from './AdminDashboard';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Assets
const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_pdf-to-website-44/artifacts/uok9y0ta_Pure%20White%20%26%20Color%20Full.png";
const LOGO_PYRAMID = "https://customer-assets.emergentagent.com/job_pdf-to-website-44/artifacts/qj4sxihc_White%20%26%20Color.png";
const FOUNDER_PHOTO = "https://customer-assets.emergentagent.com/job_pdf-to-website-44/artifacts/pu2lrzbk_IMG_6606.JPG";
const CLIENT_LOGOS = [
  { name: "Secchi", url: "https://customer-assets.emergentagent.com/job_pdf-to-website-44/artifacts/z37hri70_Secchi3.png" },
  { name: "ASFS Wealth", url: "https://customer-assets.emergentagent.com/job_pdf-to-website-44/artifacts/clnbcsyn_ASFS_Secondary%20Logo.png" },
  { name: "Wisconsin Food Allergy", url: "https://customer-assets.emergentagent.com/job_pdf-to-website-44/artifacts/nzhwoonf_Wisconsin_logo_yellow_transparent.png" },
];

// Downloadable Resources
const RESOURCE_FILES = {
  socialMediaAudit: "https://customer-assets.emergentagent.com/job_pdf-to-website-44/artifacts/8gk1trso_AMV_Social_Media_Audit_Checklist.docx",
  brandMessaging: "https://customer-assets.emergentagent.com/job_pdf-to-website-44/artifacts/0qacd6n0_AMV_Brand_Messaging_Framework.docx",
  revenueAudit: "https://customer-assets.emergentagent.com/job_pdf-to-website-44/artifacts/wblqbie4_AMV_10x_Revenue_Audit.docx",
};

// Social Links
const SOCIAL_LINKS = {
  amvInstagram: "https://www.instagram.com/abstract_mediaverse/",
  amvFacebook: "https://www.facebook.com/profile.php?id=100090022805226",
  amvLinkedIn: "https://www.linkedin.com/company/abstract-mediaverse/",
  founderLinkedIn: "https://www.linkedin.com/in/meetvan-thaker/",
  founderInstagram: "https://www.instagram.com/thesocialvairagi/",
};

const CALENDLY_URL = "https://calendly.com/abstract-mediaverse/10x-revenue-with-abstract-mediaverse-2";
const WHATSAPP_NUMBER = "918108736634";

// ==================== COMPONENTS ====================

// Legal Modal Component
const LegalModal = ({ isOpen, onClose, type }) => {
  if (!isOpen) return null;

  const content = type === 'privacy' ? {
    title: 'Privacy Policy',
    sections: [
      {
        heading: 'Introduction',
        text: 'This Privacy Policy describes how Abstract MediaVerse and its affiliates (collectively "Abstract MediaVerse, we, our, us") collect, use, share, protect or otherwise process your information/personal data through our website https://abstractmediaverse.com (hereinafter referred to as Platform).\n\nPlease note that you may be able to browse certain sections of the Platform without registering with us. We do not offer any product/service under this Platform outside India and your personal data will primarily be stored and processed in India.\n\nBy visiting this Platform, providing your information or availing any product/service offered on the Platform, you expressly agree to be bound by the terms and conditions of this Privacy Policy, the Terms of Use and the applicable service/product terms and conditions, and agree to be governed by the laws of India including but not limited to the laws applicable to data protection and privacy.'
      },
      {
        heading: 'Collection',
        text: 'We collect your personal data when you use our Platform, services or otherwise interact with us during the course of our relationship. Some of the information that we may collect includes but is not limited to personal data/information provided to us during sign-up/registering or using our Platform such as name, date of birth, address, telephone/mobile number, email ID and/or any such information shared as proof of identity or address.\n\nYou always have the option to not provide information, by choosing not to use a particular service or feature on the Platform.'
      },
      {
        heading: 'Usage',
        text: 'We use personal data to provide the services you request. To the extent we use your personal data to market to you, we will provide you the ability to opt-out of such uses. We use your personal data to assist sellers and business partners in handling and fulfilling orders; enhancing customer experience; to resolve disputes; troubleshoot problems; inform you about online and offline offers, products, services, and updates; customise your experience; detect and protect us against error, fraud and other criminal activity.'
      },
      {
        heading: 'Sharing',
        text: 'We may share your personal data internally within our group entities, our other corporate entities, and affiliates to provide you access to the services and products offered by them. We may disclose personal data to third parties such as sellers, business partners, third party service providers including logistics partners. These disclosures may be required for us to provide you access to our services and products offered to you, to comply with our legal obligations, to enforce our user agreement.'
      },
      {
        heading: 'Security Precautions',
        text: 'To protect your personal data from unauthorised access or disclosure, loss or misuse we adopt reasonable security practices and procedures. Once your information is in our possession or whenever you access your account information, we adhere to our security guidelines to protect it against unauthorised access and offer the use of a secure server.\n\nUsers are responsible for ensuring the protection of login and password records for their account.'
      },
      {
        heading: 'Data Deletion and Retention',
        text: 'You have an option to delete your account by visiting your profile and settings on our Platform. We retain your personal data information for a period no longer than is required for the purpose for which it was collected or as required under any applicable law. However, we may retain data related to you if we believe it may be necessary to prevent fraud or future abuse or for other legitimate purposes.'
      },
      {
        heading: 'Grievance Officer',
        text: 'Meetvan Thaker\nDesignation: Founder | CEO\nAbstract MediaVerse\nE9/401, Runwal Estate, Ghodbunder Road, Behind Rmall, Manpada, Thane (W) 400607\nContact: +91 8108736634\nTime: Monday - Friday (9:00 - 18:00)'
      }
    ]
  } : {
    title: 'Terms & Conditions',
    sections: [
      {
        heading: 'Introduction',
        text: 'This document is an electronic record in terms of Information Technology Act, 2000 and rules there under as applicable. This document is published in accordance with the provisions of Rule 3 (1) of the Information Technology (Intermediaries guidelines) Rules, 2011.\n\nThe Platform is owned by Abstract MediaVerse, a company incorporated under the Companies Act, 1956 with its registered office at E9/401, Runwal Estate, Ghodbunder Road, Behind Rmall, Manpada, Thane (W) 400607.'
      },
      {
        heading: 'Terms of Use',
        text: 'Your use of the Platform and services and tools are governed by the following terms and conditions ("Terms of Use") as applicable to the Platform including the applicable policies which are incorporated herein by way of reference. By mere use of the Platform, You shall be contracting with the Platform Owner and these terms and conditions including the policies constitute Your binding obligations.\n\nACCESSING, BROWSING OR OTHERWISE USING THE PLATFORM INDICATES YOUR AGREEMENT TO ALL THE TERMS AND CONDITIONS UNDER THESE TERMS OF USE.'
      },
      {
        heading: 'User Responsibilities',
        text: 'To access and use the Services, you agree to provide true, accurate and complete information to us during and after registration, and you shall be responsible for all acts done through the use of your registered account on the Platform.\n\nYour use of our Services and the Platform is solely and entirely at your own risk and discretion for which we shall not be liable to you in any manner. You are required to independently assess and ensure that the Services meet your requirements.'
      },
      {
        heading: 'Intellectual Property',
        text: 'The contents of the Platform and the Services are proprietary to us and are licensed to us. You will not have any authority to claim any intellectual property rights, title, or interest in its contents. The contents includes and is not limited to the design, layout, look and graphics.\n\nYou acknowledge that unauthorized use of the Platform and/or the Services may lead to action against you as per these Terms of Use and/or applicable laws.'
      },
      {
        heading: 'Third Party Links',
        text: 'You agree and acknowledge that website and the Services may contain links to other third party websites. On accessing these links, you will be governed by the terms of use, privacy policy and such other policies of such third party websites. These links are provided for your convenience for provide further information.'
      },
      {
        heading: 'Indemnification',
        text: 'You shall indemnify and hold harmless Platform Owner, its affiliates, group companies (as applicable) and their respective officers, directors, agents, and employees, from any claim or demand, or actions including reasonable attorney\'s fees, made by any third party or penalty imposed due to or arising out of Your breach of this Terms of Use, Privacy Policy and other Policies.'
      },
      {
        heading: 'Governing Law',
        text: 'These Terms and any dispute or claim relating to it, or its enforceability, shall be governed by and construed in accordance with the laws of India. All disputes arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts in Mumbai and Maharashtra.\n\nAll concerns or communications relating to these Terms must be communicated to us using the contact information provided on this website.'
      }
    ]
  };

  return (
    <div className="modal-backdrop flex items-center justify-center p-4 z-[200]" onClick={onClose}>
      <div 
        className="bg-[#161616] rounded-2xl max-w-3xl w-full max-h-[85vh] overflow-hidden border border-white/10 relative flex flex-col"
        onClick={e => e.stopPropagation()}
        data-testid={`${type}-modal`}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-white/10 flex-shrink-0">
          <h2 className="text-2xl font-bold font-display">{content.title}</h2>
          <button 
            onClick={onClose} 
            className="text-gray-400 hover:text-white p-2"
            data-testid="legal-modal-close"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        {/* Content */}
        <div className="overflow-y-auto p-6 flex-1">
          <div className="space-y-6">
            {content.sections.map((section, idx) => (
              <div key={section.heading}>
                <h3 className="text-lg font-semibold text-[#A855F7] mb-3">{section.heading}</h3>
                <p className="text-gray-300 text-sm leading-relaxed whitespace-pre-line">{section.text}</p>
              </div>
            ))}
          </div>
          
          <div className="mt-8 pt-6 border-t border-white/10 text-center">
            <p className="text-gray-500 text-sm">© 2026 Abstract MediaVerse. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

// Floating WhatsApp Button
const FloatingWhatsApp = () => {
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=Hi%2C%20I%27m%20interested%20in%20learning%20more%20about%20Abstract%20MediaVerse%20services.`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-20 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform hover:shadow-[#25D366]/40 hover:shadow-xl"
      data-testid="floating-whatsapp-btn"
      title="Chat on WhatsApp"
    >
      <svg className="w-7 h-7 text-white" fill="currentColor" viewBox="0 0 24 24">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
    </a>
  );
};

// Timed Popup (20 seconds)
const TimedPopup = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', company: '', country: '', budget_range: '', message: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/leads`, { 
        ...formData, 
        source: 'timed_popup'
      });
      if (window.fbq) window.fbq('track', 'Lead', { content_name: 'timed_popup' });
      setSuccess(true);
      setTimeout(() => onClose(), 2000);
    } catch (err) {
      if (process.env.NODE_ENV === 'development') console.error('Error:', err);
    }
    setLoading(false);
  };

  return (
    <div className="modal-backdrop flex items-center justify-center p-4 z-[150]" onClick={onClose}>
      <div 
        className="bg-[#161616] rounded-2xl p-8 max-w-lg w-full border border-white/10 relative overflow-hidden max-h-[90vh] overflow-y-auto"
        onClick={e => e.stopPropagation()}
        data-testid="timed-popup"
      >
        {/* Decorative gradient */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-[#A855F7]/10 rounded-full blur-[80px] -translate-y-1/2 translate-x-1/2" />
        
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 text-gray-400 hover:text-white z-10"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {success ? (
          <div className="text-center py-8 relative z-10">
            <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h3 className="text-xl font-bold mb-2">You're In!</h3>
            <p className="text-gray-400">We'll reach out with your free growth strategy.</p>
          </div>
        ) : (
          <div className="relative z-10">
            <div className="text-center mb-6">
              <span className="inline-block px-3 py-1 bg-[#FF9F43]/20 text-[#FF9F43] rounded-full text-xs font-medium mb-3">
                Limited Time Offer
              </span>
              <h3 className="text-2xl font-bold mb-2 font-display">
                Get Your Free <span className="gradient-text">Growth Strategy</span>
              </h3>
              <p className="text-gray-400 text-sm">
                Let us analyze your business and show you exactly how to 10x your revenue.
              </p>
            </div>
            
            <form onSubmit={handleSubmit} className="space-y-3">
              <input type="text" placeholder="Your Name *" className="form-input" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} required />
              <input type="email" placeholder="Email Address *" className="form-input" value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} required />
              <input type="tel" placeholder="Phone Number *" className="form-input" value={formData.phone} onChange={e => setFormData({...formData, phone: e.target.value})} required />
              <input type="text" placeholder="Company Name" className="form-input" value={formData.company} onChange={e => setFormData({...formData, company: e.target.value})} />
              <input type="text" placeholder="Country *" className="form-input" value={formData.country} onChange={e => setFormData({...formData, country: e.target.value})} required />
              <select className="form-input" value={formData.budget_range} onChange={e => setFormData({...formData, budget_range: e.target.value})} required>
                <option value="">Budget Range *</option>
                <option value="Under USD 1500">Under USD 1500</option>
                <option value="USD 1500-3000">USD 1500 - 3000</option>
                <option value="USD 3000-5000">USD 3000 - 5000</option>
                <option value="USD 5000+">USD 5000+</option>
              </select>
              <textarea placeholder="About Your Business" className="form-input min-h-[80px]" value={formData.message} onChange={e => setFormData({...formData, message: e.target.value})} />
              <button type="submit" className="w-full py-4 bg-gradient-to-r from-[#A855F7] to-[#FF5C8A] rounded-xl text-white font-semibold hover:opacity-90 transition-opacity" disabled={loading}>
                {loading ? 'Submitting...' : 'Claim My Free Strategy →'}
              </button>
            </form>
            <p className="text-gray-500 text-xs text-center mt-4">
              No spam. Just actionable growth insights.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

// Exit Intent Popup
const ExitIntentPopup = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', company: '', country: '', budget_range: '', message: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/leads`, { 
        ...formData, 
        source: 'exit_intent_popup'
      });
      if (window.fbq) window.fbq('track', 'Lead', { content_name: 'exit_intent_popup' });
      setSuccess(true);
      setTimeout(() => onClose(), 2000);
    } catch (err) {
      if (process.env.NODE_ENV === 'development') console.error('Error:', err);
    }
    setLoading(false);
  };

  return (
    <div className="modal-backdrop flex items-center justify-center p-4 z-[150]" onClick={onClose}>
      <div 
        className="bg-[#161616] rounded-2xl p-8 max-w-lg w-full border border-[#FF5C8A]/30 relative overflow-hidden max-h-[90vh] overflow-y-auto"
        onClick={e => e.stopPropagation()}
        data-testid="exit-intent-popup"
      >
        {/* Decorative gradient */}
        <div className="absolute top-0 left-0 w-64 h-64 bg-[#FF5C8A]/10 rounded-full blur-[80px] -translate-y-1/2 -translate-x-1/2" />
        
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 text-gray-400 hover:text-white z-10"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {success ? (
          <div className="text-center py-8 relative z-10">
            <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h3 className="text-xl font-bold mb-2">Thank You!</h3>
            <p className="text-gray-400">Your free audit is on its way.</p>
          </div>
        ) : (
          <div className="relative z-10">
            <div className="text-center mb-6">
              <span className="inline-block px-3 py-1 bg-[#FF5C8A]/20 text-[#FF5C8A] rounded-full text-xs font-medium mb-3">
                Wait! Before You Go...
              </span>
              <h3 className="text-2xl font-bold mb-2 font-display">
                Don't Miss Your <span className="gradient-text-orange">Free Audit</span>
              </h3>
              <p className="text-gray-400 text-sm">
                Get a personalized 30-minute growth audit worth $500 — absolutely free.
              </p>
            </div>
            
            <form onSubmit={handleSubmit} className="space-y-3">
              <input type="text" placeholder="Your Name *" className="form-input" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} required />
              <input type="email" placeholder="Email Address *" className="form-input" value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} required />
              <input type="tel" placeholder="Phone Number *" className="form-input" value={formData.phone} onChange={e => setFormData({...formData, phone: e.target.value})} required />
              <input type="text" placeholder="Company Name" className="form-input" value={formData.company} onChange={e => setFormData({...formData, company: e.target.value})} />
              <input type="text" placeholder="Country *" className="form-input" value={formData.country} onChange={e => setFormData({...formData, country: e.target.value})} required />
              <select className="form-input" value={formData.budget_range} onChange={e => setFormData({...formData, budget_range: e.target.value})} required>
                <option value="">Budget Range *</option>
                <option value="Under USD 1500">Under USD 1500</option>
                <option value="USD 1500-3000">USD 1500 - 3000</option>
                <option value="USD 3000-5000">USD 3000 - 5000</option>
                <option value="USD 5000+">USD 5000+</option>
              </select>
              <textarea placeholder="About Your Business" className="form-input min-h-[80px]" value={formData.message} onChange={e => setFormData({...formData, message: e.target.value})} />
              <button type="submit" className="w-full py-4 bg-gradient-to-r from-[#FF5C8A] to-[#FF9F43] rounded-xl text-white font-semibold hover:opacity-90 transition-opacity" disabled={loading}>
                {loading ? 'Submitting...' : 'Yes! Send My Free Audit →'}
              </button>
            </form>
            <button onClick={onClose} className="w-full text-gray-500 text-sm mt-4 hover:text-gray-300 transition-colors">
              No thanks, I don't want to grow my business
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

// Popup Manager Hook
const usePopupManager = () => {
  const [showTimedPopup, setShowTimedPopup] = useState(false);
  const [showExitPopup, setShowExitPopup] = useState(false);
  const [hasShownTimed, setHasShownTimed] = useState(false);
  const [hasShownExit, setHasShownExit] = useState(false);

  useEffect(() => {
    // Check if popups were already shown this session
    const timedShown = sessionStorage.getItem('amv_timed_popup_shown');
    const exitShown = sessionStorage.getItem('amv_exit_popup_shown');
    
    if (timedShown) setHasShownTimed(true);
    if (exitShown) setHasShownExit(true);

    // 20-second timed popup
    if (!timedShown) {
      const timer = setTimeout(() => {
        setShowTimedPopup(true);
        setHasShownTimed(true);
        sessionStorage.setItem('amv_timed_popup_shown', 'true');
      }, 20000);
      
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    // Exit intent detection
    const handleMouseLeave = (e) => {
      if (e.clientY <= 0 && !hasShownExit && !showTimedPopup) {
        setShowExitPopup(true);
        setHasShownExit(true);
        sessionStorage.setItem('amv_exit_popup_shown', 'true');
      }
    };

    document.addEventListener('mouseleave', handleMouseLeave);
    return () => document.removeEventListener('mouseleave', handleMouseLeave);
  }, [hasShownExit, showTimedPopup]);

  return {
    showTimedPopup,
    showExitPopup,
    closeTimedPopup: () => setShowTimedPopup(false),
    closeExitPopup: () => setShowExitPopup(false)
  };
};

// Navigation
const Navigation = ({ showModal }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'About', href: '#about' },
    { label: 'Services', href: '#services' },
    { label: 'Clients', href: '#clients' },
    { label: 'Resources', href: '#resources' },
    { label: 'Contact', href: '#contact' },
  ];

  const isHome = location.pathname === '/';

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#0D0D0D]/95 backdrop-blur-lg border-b border-white/5' : ''}`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img src={LOGO_WHITE} alt="Abstract MediaVerse" className="h-12" />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8">
            {isHome ? (
              navLinks.map((link, idx) => (
                <a key={link.href} href={link.href} className="text-gray-300 hover:text-white transition-colors text-sm font-medium">
                  {link.label}
                </a>
              ))
            ) : (
              <Link to="/" className="text-gray-300 hover:text-white transition-colors text-sm font-medium">Home</Link>
            )}
            <Link to="/blog" className="text-gray-300 hover:text-white transition-colors text-sm font-medium">Blog</Link>
          </nav>

          <div className="hidden lg:block">
            <button 
              onClick={() => { if (window.fbq) window.fbq('track', 'Schedule'); window.open(CALENDLY_URL, '_blank'); }}
              className="btn-primary"
              data-testid="nav-book-audit-btn"
            >
              <span>Book a Free Audit</span>
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="lg:hidden text-white p-2"
            onClick={() => setMobileOpen(!mobileOpen)}
            data-testid="mobile-menu-btn"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {mobileOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Nav */}
        {mobileOpen && (
          <nav className="lg:hidden mt-4 pb-4 border-t border-white/10 pt-4 flex flex-col gap-4 bg-[#0D0D0D]">
            {isHome && navLinks.map((link, idx) => (
              <a key={link.href} href={link.href} className="text-gray-300 hover:text-white transition-colors py-2" onClick={() => setMobileOpen(false)}>
                {link.label}
              </a>
            ))}
            <Link to="/blog" className="text-gray-300 hover:text-white transition-colors py-2" onClick={() => setMobileOpen(false)}>Blog</Link>
            <button 
              onClick={() => { if (window.fbq) window.fbq('track', 'Schedule'); window.open(CALENDLY_URL, '_blank'); }}
              className="btn-primary w-full mt-2"
            >
              <span>Book a Free Audit</span>
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};

// Resource Download Modal - Captures lead before download
const ResourceDownloadModal = ({ isOpen, onClose, resource }) => {
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', business_description: '', country: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Save lead to database
      await axios.post(`${API}/leads`, { 
        ...formData, 
        source: `resource_download_${resource?.title?.toLowerCase().replace(/\s+/g, '_')}`,
        message: `Downloaded: ${resource?.title}`
      });
      if (window.fbq) window.fbq('track', 'Lead', { content_name: 'resource_download' });
      
      // Trigger download
      if (resource?.download_url) {
        window.open(resource.download_url, '_blank');
      }
      
      // Close modal and reset
      onClose();
      setFormData({ name: '', email: '', phone: '', business_description: '', country: '' });
    } catch (err) {
      if (process.env.NODE_ENV === 'development') console.error('Error submitting:', err);
      // Still allow download on error
      if (resource?.download_url) {
        window.open(resource.download_url, '_blank');
      }
      onClose();
    }
    setLoading(false);
  };

  if (!isOpen || !resource) return null;

  return (
    <div className="modal-backdrop flex items-center justify-center p-4" onClick={onClose}>
      <div 
        className="bg-[#161616] rounded-2xl p-8 max-w-lg w-full border border-white/10 relative"
        onClick={e => e.stopPropagation()}
        data-testid="resource-download-modal"
      >
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 text-gray-400 hover:text-white"
          data-testid="resource-modal-close"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <div className="mb-6">
          <div className="inline-block px-3 py-1 bg-green-500/20 text-green-400 rounded-full text-xs font-medium mb-3">
            Free Download
          </div>
          <h3 className="text-2xl font-bold mb-2 font-display">{resource.title}</h3>
          <p className="text-gray-400 text-sm">Enter your details below to download this resource.</p>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            placeholder="Your Name *"
            className="form-input"
            value={formData.name}
            onChange={e => setFormData({...formData, name: e.target.value})}
            required
            data-testid="resource-name-input"
          />
          <input
            type="email"
            placeholder="Email Address *"
            className="form-input"
            value={formData.email}
            onChange={e => setFormData({...formData, email: e.target.value})}
            required
            data-testid="resource-email-input"
          />
          <input
            type="tel"
            placeholder="Phone Number *"
            className="form-input"
            value={formData.phone}
            onChange={e => setFormData({...formData, phone: e.target.value})}
            required
            data-testid="resource-phone-input"
          />
          <input
            type="text"
            placeholder="Business / Job Description *"
            className="form-input"
            value={formData.business_description}
            onChange={e => setFormData({...formData, business_description: e.target.value})}
            required
            data-testid="resource-business-input"
          />
          <input
            type="text"
            placeholder="Country *"
            className="form-input"
            value={formData.country}
            onChange={e => setFormData({...formData, country: e.target.value})}
            required
            data-testid="resource-country-input"
          />
          <button 
            type="submit" 
            className="btn-primary w-full" 
            disabled={loading}
            data-testid="resource-download-btn"
          >
            <span>{loading ? 'Processing...' : 'Download Now'}</span>
          </button>
          <p className="text-gray-500 text-xs text-center">
            By downloading, you agree to receive occasional updates from Abstract MediaVerse.
          </p>
        </form>
      </div>
    </div>
  );
};

// Lead Form Modal
const LeadFormModal = ({ isOpen, onClose, source = "enquiry_form" }) => {
  const [formData, setFormData] = useState({
    name: '', email: '', company: '', country: '', budget_range: '', message: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/leads`, { ...formData, source });
      if (window.fbq) window.fbq('track', 'Lead', { content_name: source });
      setSuccess(true);
      setTimeout(() => {
        onClose();
        setSuccess(false);
        setFormData({ name: '', email: '', company: '', country: '', budget_range: '', message: '' });
      }, 2000);
    } catch (err) {
      if (process.env.NODE_ENV === 'development') console.error('Error submitting lead:', err);
    }
    setLoading(false);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-backdrop flex items-center justify-center p-4" onClick={onClose}>
      <div 
        className="bg-[#161616] rounded-2xl p-8 max-w-lg w-full border border-white/10 relative"
        onClick={e => e.stopPropagation()}
        data-testid="lead-form-modal"
      >
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 text-gray-400 hover:text-white"
          data-testid="modal-close-btn"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {success ? (
          <div className="text-center py-8">
            <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h3 className="text-xl font-bold mb-2">Transmission Received!</h3>
            <p className="text-gray-400">We'll be in touch within 24 hours.</p>
          </div>
        ) : (
          <>
            <h3 className="text-2xl font-bold mb-2 font-display">Let's Talk Growth</h3>
            <p className="text-gray-400 mb-6">Tell us about your business and we'll craft a custom proposal.</p>
            
            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                type="text"
                placeholder="Your Name"
                className="form-input"
                value={formData.name}
                onChange={e => setFormData({...formData, name: e.target.value})}
                required
                data-testid="lead-name-input"
              />
              <input
                type="email"
                placeholder="Email Address"
                className="form-input"
                value={formData.email}
                onChange={e => setFormData({...formData, email: e.target.value})}
                required
                data-testid="lead-email-input"
              />
              <input
                type="text"
                placeholder="Company Name"
                className="form-input"
                value={formData.company}
                onChange={e => setFormData({...formData, company: e.target.value})}
                required
                data-testid="lead-company-input"
              />
              <input
                type="text"
                placeholder="Country"
                className="form-input"
                value={formData.country}
                onChange={e => setFormData({...formData, country: e.target.value})}
                required
                data-testid="lead-country-input"
              />
              <select
                className="form-input"
                value={formData.budget_range}
                onChange={e => setFormData({...formData, budget_range: e.target.value})}
                required
                data-testid="lead-budget-select"
              >
                <option value="">Select Budget Range</option>
                <option value="Under USD 1500">Under USD 1500</option>
                <option value="USD 1500-3000">USD 1500 - 3000</option>
                <option value="USD 3000-5000">USD 3000 - 5000</option>
                <option value="USD 5000+">USD 5000+</option>
              </select>
              <textarea
                placeholder="About Your Business (optional)"
                className="form-input min-h-[100px]"
                value={formData.message}
                onChange={e => setFormData({...formData, message: e.target.value})}
                data-testid="lead-message-input"
              />
              <button 
                type="submit" 
                className="btn-primary w-full" 
                disabled={loading}
                data-testid="lead-submit-btn"
              >
                <span>{loading ? 'Sending...' : 'Send Enquiry'}</span>
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

// Hero Section
const HeroSection = () => {
  return (
    <section id="hero" className="min-h-screen pt-24 pb-20 relative overflow-hidden bg-grid noise-overlay">
      {/* Gradient orbs */}
      <div className="absolute top-20 right-0 w-[600px] h-[600px] bg-[#A855F7]/10 rounded-full blur-[150px] pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-[#00D4FF]/5 rounded-full blur-[120px] pointer-events-none" />
      
      <div className="max-w-7xl mx-auto px-6 pt-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8 fade-in">
            {/* Signal badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#A855F7]/10 border border-[#A855F7]/30 rounded-full">
              <span className="w-2 h-2 bg-[#A855F7] rounded-full pulse-dot" />
              <span className="text-[#A855F7] text-sm font-medium">Digital Growth Partner</span>
            </div>

            <h1 className="text-5xl lg:text-7xl font-black leading-[1.05] font-display" data-testid="hero-headline">
              Your Vision.
              <span className="block gradient-text">Our Strategy.</span>
              <span className="block">One Goal</span>
              <span className="block gradient-text">10x Growth</span>
            </h1>

            <p className="text-xl text-gray-400 max-w-xl leading-relaxed">
              We help stable, growth-ready businesses in the <span className="text-white">USA</span> and <span className="text-white">UAE</span> scale revenue with sharp strategy, creative execution, and AI-powered marketing.
            </p>

            <div className="flex flex-col gap-3 max-w-md">
              <button 
                onClick={() => { if (window.fbq) window.fbq('track', 'Schedule'); window.open(CALENDLY_URL, '_blank'); }}
                className="w-full py-4 px-6 bg-gradient-to-r from-[#A855F7] to-[#FF5C8A] rounded-full text-white font-semibold hover:opacity-90 transition-all hover:shadow-lg hover:shadow-[#A855F7]/25"
                data-testid="hero-book-audit-btn"
              >
                Book Your Free 30-Min Growth Audit
              </button>
              <a href="#services" className="w-full py-4 px-6 border border-white/20 rounded-full text-white font-semibold hover:bg-white/5 transition-all text-center">
                Explore Our Plans
              </a>
            </div>
          </div>

          {/* Pyramid graphic */}
          <div className="hidden lg:flex justify-center items-center relative">
            <div className="relative">
              <img 
                src={LOGO_PYRAMID} 
                alt="Abstract MediaVerse" 
                className="w-80 h-80 object-contain"
                style={{ filter: 'drop-shadow(0 0 60px rgba(168, 85, 247, 0.3))' }}
              />
              {/* Floating stats with animation */}
              <div className="absolute -top-4 -right-8 bg-[#161616] border border-white/10 rounded-xl p-4 backdrop-blur-sm animate-float">
                <div className="text-2xl font-bold text-[#00D4FF]">150+</div>
                <div className="text-xs text-gray-400">Projects</div>
              </div>
              <div className="absolute -bottom-4 -left-8 bg-[#161616] border border-white/10 rounded-xl p-4 backdrop-blur-sm animate-float-delayed">
                <div className="text-2xl font-bold text-[#FF9F43]">10x</div>
                <div className="text-xs text-gray-400">Growth</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// AMV Angle Section
const AMVAngleSection = () => {
  const proofBlocks = [
    { value: '150+', label: 'Projects Delivered', color: '#A855F7' },
    { value: 'Serving Globally', label: 'USA, UAE & India', color: '#00D4FF' },
    { value: 'Full-ownership', label: 'For Your Marketing Activities', color: '#FF9F43' },
  ];

  return (
    <section id="about" className="section bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-4xl mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6 font-display" data-testid="amv-angle-headline">
            We Choose Our Clients Carefully - <span className="gradient-text">Ensuring Maximum Alignment and Results.</span>
          </h2>
          <p className="text-xl text-gray-400 leading-relaxed">
            We work with businesses that are stable, seasoned, and serious about growth. Not startups chasing survival — but founders and executives ready to scale intelligently with a dedicated marketing partner by their side.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 stagger-children">
          {proofBlocks.map((block, idx) => (
            <div key={block.label} className="card text-center flex flex-col items-center justify-center" data-testid={`proof-block-${idx}`}>
              <div className="text-4xl lg:text-5xl font-black mb-2 font-display" style={{ color: block.color }}>
                {block.value}
              </div>
              <div className="text-gray-400">{block.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Services Section
const ServicesSection = ({ onEnquire }) => {
  const cmoTiers = [
    {
      name: 'Launchpad',
      price: 'USD 1,500/mo',
      onboarding: '+ USD 500 onboarding',
      tagline: 'Get your marketing engine off the ground.',
      bestFor: 'Stable businesses with a clear product or service, ready to establish a consistent, professional digital presence.',
      features: [
        'Market Research & Competitive Gap Analysis',
        'Brand Presence Audit & Strategy Roadmap',
        'Social Media Content — up to 12 posts/month',
        'Presence on 2 platforms (Meta + 1)',
        'SEO Blog — 2 articles/month',
        'Strategic Consultation — 2x/month',
      ],
      cta: 'Enquire Now',
      featured: false,
    },
    {
      name: 'Signal Boost',
      price: 'USD 3,000/mo',
      onboarding: '+ USD 750 onboarding',
      tagline: 'Amplify what\'s working. Fix what isn\'t. Scale with intent.',
      bestFor: 'Growth-stage businesses ready to activate paid media, deepen content strategy, and see measurable ROI.',
      features: [
        'Everything in Launchpad, plus:',
        'Social Media — up to 16 posts/month',
        'Meta Ads + Google Ads Management',
        'ROAS Tracking & Monthly Performance Report',
        'SEO Blog — 4 articles/month',
        'Email Marketing — Newsletters + Campaigns',
        'PR & Influencer Outreach (1/quarter)',
        'Dedicated Account Manager',
      ],
      cta: 'Enquire Now',
      featured: true,
      badge: 'Most Popular',
    },
    {
      name: 'Full Orbit',
      price: 'USD 5,000/mo',
      onboarding: '+ USD 1,000 onboarding',
      tagline: 'Total marketing ownership. We deploy the full crew.',
      bestFor: 'Established operators who want a senior marketing partner fully embedded in their growth strategy.',
      features: [
        'Everything in Signal Boost, plus:',
        'Social Media — up to 20 posts/month',
        'Full Ad Management (Meta + Google + LinkedIn)',
        'UGC Direction & Influencer Management',
        'Full SEO Programme',
        'Website Revamp or Ongoing Development',
        'Dedicated Brand Team',
        'Weekly Touchpoint + Monthly Deep-Dive',
        'Priority Response — 4 business hours',
      ],
      cta: 'Let\'s Talk',
      featured: false,
      isCalendly: true,
      guarantee: 'If agreed deliverables are not met, we rectify within 7 working days or extend your service at no cost.',
    },
  ];

  const standaloneMissions = [
    { name: 'Signal Ignition', subtitle: 'AI Lead Generation', tagline: 'Stop waiting for leads. Engineer them.', icon: '🎯' },
    { name: 'Content Reactor', subtitle: 'AI Content Engine', tagline: 'One conversation. Thirty days of content.', icon: '⚡' },
    { name: 'Command Stack', subtitle: 'Automation Setup', tagline: 'Build once. Run forever.', icon: '🔧' },
    { name: 'Intel Drop', subtitle: 'Monthly AI Marketing Report', tagline: 'Know what\'s moving before competitors do.', icon: '📊' },
    { name: 'Base Station', subtitle: 'Web Development', tagline: 'Your website should be your best salesperson.', icon: '🌐' },
    { name: 'Identity Transmission', subtitle: 'Brand Identity', tagline: 'Signal who you are before you say a word.', icon: '✨' },
    { name: 'Frequency Management', subtitle: 'Social Media Management', tagline: 'Keep your signal strong. Stay top of mind.', icon: '📡' },
  ];

  return (
    <section id="services" className="section">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-[#A855F7]/10 border border-[#A855F7]/30 rounded-full text-[#A855F7] text-sm font-medium mb-4">
            Fractional CMO
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold mb-4 font-display" data-testid="services-headline">
            One Flagship. <span className="gradient-text">Total Clarity.</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Choose your trajectory — and we'll handle the rest.
          </p>
        </div>

        {/* CMO Tiers */}
        <div className="grid lg:grid-cols-3 gap-6 mb-20">
          {cmoTiers.map((tier, idx) => (
            <div 
              key={tier.name} 
              className={`card relative flex flex-col h-full ${tier.featured ? 'card-featured' : ''}`}
              data-testid={`cmo-tier-${idx}`}
            >
              {tier.badge && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 bg-gradient-to-r from-[#A855F7] to-[#FF5C8A] rounded-full text-xs font-semibold">
                  {tier.badge}
                </div>
              )}
              <div className="flex-grow">
                <h3 className="text-2xl font-bold mb-2 font-display pt-2">{tier.name}</h3>
                <div className="text-3xl font-black gradient-text mb-1">{tier.price}</div>
                <div className="text-sm text-gray-500 mb-6">{tier.onboarding}</div>
                <p className="text-[#00D4FF] text-sm mb-4">{tier.tagline}</p>
                <p className="text-gray-400 text-sm mb-8">{tier.bestFor}</p>
                
                <ul className="space-y-3 mb-8">
                  {tier.features.map((feature, fIdx) => (
                    <li key={fIdx} className="flex items-start gap-2 text-sm text-gray-300">
                      <svg className="w-4 h-4 text-[#A855F7] mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      {feature}
                    </li>
                  ))}
                </ul>

                {tier.guarantee && (
                  <p className="text-xs text-[#FF9F43] mb-6 p-3 bg-[#FF9F43]/10 rounded-lg">
                    {tier.guarantee}
                  </p>
                )}
              </div>

              <button 
                onClick={() => tier.isCalendly ? (function(){ if (window.fbq) window.fbq('track', 'Schedule'); window.open(CALENDLY_URL, '_blank'); })() : onEnquire()}
                className={`w-full mt-auto ${tier.featured ? 'btn-primary' : 'btn-secondary'}`}
                data-testid={`cmo-tier-${idx}-cta`}
              >
                <span>{tier.cta}</span>
              </button>
            </div>
          ))}
        </div>

        {/* Standalone Missions */}
        <div className="border-t border-white/10 pt-16">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold mb-4 font-display">Standalone Missions</h3>
            <p className="text-gray-400 max-w-2xl mx-auto">
              Need something specific in your arsenal? Deploy any of these independently — or fold them into your orbit.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 stagger-children">
            {standaloneMissions.map((mission, idx) => (
              <div key={mission.name} className="card group cursor-pointer" onClick={onEnquire} data-testid={`standalone-${idx}`}>
                <div className="text-3xl mb-3">{mission.icon}</div>
                <h4 className="font-bold text-lg mb-1">{mission.name}</h4>
                <p className="text-[#A855F7] text-sm mb-2">{mission.subtitle}</p>
                <p className="text-gray-400 text-sm mb-4">{mission.tagline}</p>
                <span className="text-sm text-white/60 group-hover:text-[#00D4FF] transition-colors">
                  Enquire Now →
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

// Clients Section
const ClientsSection = () => {
  const caseStudies = [
    {
      name: 'Secchi',
      sector: 'SaaS / ERM',
      geography: 'Global',
      challenge: 'Building digital presence and strategic marketing foundation for a B2B SaaS product with a seasoned founding team.',
      outcomes: 'LinkedIn impressions up 40.3%, engagement up 53.2%, comments surged 550%. Cross-platform social media strategy driving 41% non-follower engagement on Instagram.',
    },
    {
      name: 'Wisconsin Food Allergy',
      sector: 'Healthcare',
      geography: 'USA',
      challenge: 'Growing patient reach and digital authority for a specialist food allergy practice.',
      outcomes: 'SEO content architecture built, long-form blog strategy deployed, consistent organic growth pipeline established.',
    },
  ];

  return (
    <section id="clients" className="section bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold mb-4 font-display" data-testid="clients-headline">
            The Companies We <span className="gradient-text">Grow With</span>
          </h2>
        </div>

        {/* Logo Marquee */}
        <div className="relative overflow-hidden py-12 mb-16">
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#0a0a0a] to-transparent z-10" />
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#0a0a0a] to-transparent z-10" />
          
          <div className="flex marquee-track" data-testid="logo-marquee">
            {[...CLIENT_LOGOS, ...CLIENT_LOGOS, ...CLIENT_LOGOS].map((logo, idx) => (
              <div key={`${logo.name}-${idx}`} className="flex-shrink-0 mx-12 opacity-60 hover:opacity-100 transition-opacity">
                <img src={logo.url} alt={logo.name} className="h-16 w-auto object-contain filter grayscale hover:grayscale-0 transition-all" />
              </div>
            ))}
          </div>
          
          <p className="text-center text-gray-500 text-sm mt-8">
            Trusted by founders and operators across industries and geographies.
          </p>
        </div>

        {/* Case Studies */}
        <div className="border-t border-white/10 pt-16">
          <h3 className="text-2xl font-bold mb-8 font-display">A few missions worth talking about.</h3>
          
          <div className="grid md:grid-cols-2 gap-6">
            {caseStudies.map((study, idx) => (
              <div key={study.name} className="card" data-testid={`case-study-${idx}`}>
                <div className="flex items-center gap-4 mb-4">
                  <h4 className="text-xl font-bold">{study.name}</h4>
                </div>
                <div className="flex gap-4 mb-4 text-sm">
                  <span className="px-3 py-1 bg-[#A855F7]/10 text-[#A855F7] rounded-full">{study.sector}</span>
                  <span className="px-3 py-1 bg-[#00D4FF]/10 text-[#00D4FF] rounded-full">{study.geography}</span>
                </div>
                <p className="text-gray-400 mb-4"><strong className="text-white">Challenge:</strong> {study.challenge}</p>
                <p className="text-gray-400"><strong className="text-[#FF9F43]">Outcomes:</strong> {study.outcomes}</p>
              </div>
            ))}
          </div>
          
          <p className="text-gray-500 text-sm mt-8 text-center">Case studies updated regularly</p>
        </div>
      </div>
    </section>
  );
};

// Founder Section
const FounderSection = () => {
  return (
    <section id="founder" className="section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Photo */}
          <div className="flex justify-center lg:justify-start order-2 lg:order-1">
            <div className="relative">
              <div className="w-80 h-96 rounded-3xl border border-white/10 overflow-hidden" data-testid="founder-photo">
                <img 
                  src={FOUNDER_PHOTO} 
                  alt="Meetvan Thaker - Founder of Abstract MediaVerse" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Decorative triangles */}
              <div className="absolute -top-3 -right-3 w-6 h-6 bg-[#00D4FF] transform rotate-45" />
              <div className="absolute -bottom-3 -left-3 w-6 h-6 bg-[#FF9F43] transform rotate-45" />
            </div>
          </div>

          {/* Bio */}
          <div className="space-y-6 order-1 lg:order-2">
            <span className="inline-block px-4 py-1.5 bg-[#FF9F43]/10 border border-[#FF9F43]/30 rounded-full text-[#FF9F43] text-sm font-medium">
              Leadership
            </span>
            <h2 className="text-4xl lg:text-5xl font-bold font-display" data-testid="founder-headline">
              <span className="gradient-text-orange">Meetvan Thaker</span>
            </h2>
            <p className="text-xl text-gray-400 leading-relaxed">
              Founder of Abstract MediaVerse. Published poet. Certified digital marketer (IIT-Roorkee). 150+ projects delivered across sectors and geographies.
            </p>
            <p className="text-gray-400 leading-relaxed">
              He builds brand strategies the way a good story is written — with structure, soul, and a clear destination. His philosophy lives at the intersection of ancient wisdom and modern marketing science, which he calls{' '}
              <a 
                href={SOCIAL_LINKS.founderInstagram} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#A855F7] hover:underline"
              >
                The Social Vairagi
              </a>.
            </p>
            
            {/* Social links */}
            <div className="flex gap-4 pt-4">
              <a 
                href={SOCIAL_LINKS.founderLinkedIn} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-12 h-12 bg-white/5 border border-white/10 rounded-xl flex items-center justify-center hover:bg-[#0077B5] hover:border-[#0077B5] transition-all" 
                data-testid="founder-linkedin"
                title="LinkedIn"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>
              </a>
              <a 
                href={SOCIAL_LINKS.founderInstagram} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-12 h-12 bg-white/5 border border-white/10 rounded-xl flex items-center justify-center hover:bg-gradient-to-br hover:from-[#f09433] hover:via-[#e6683c] hover:to-[#bc1888] hover:border-transparent transition-all" 
                data-testid="founder-instagram"
                title="Instagram - The Social Vairagi"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Resources Section
const ResourcesSection = () => {
  const [filter, setFilter] = useState('All');
  const [downloadModal, setDownloadModal] = useState({ open: false, resource: null });
  const categories = ['All', 'Strategy', 'Content', 'Ads', 'AI & Automation', 'Brand'];

  const resources = [
    { 
      id: '1', 
      title: 'Social Media Audit Checklist', 
      description: 'A no-fluff checklist to diagnose what\'s working, what\'s dead weight, and what to fix first across your social channels.', 
      category: 'Strategy', 
      is_free: true,
      download_url: RESOURCE_FILES.socialMediaAudit
    },
    { 
      id: '2', 
      title: 'Brand Messaging Framework', 
      description: 'A comprehensive framework to define your brand voice, messaging pillars, and communication strategy.', 
      category: 'Brand', 
      is_free: true,
      download_url: RESOURCE_FILES.brandMessaging
    },
    { 
      id: '3', 
      title: '10x Revenue Audit Template', 
      description: 'The same audit framework we use to identify growth opportunities for our retainer clients.', 
      category: 'Strategy', 
      is_free: true,
      download_url: RESOURCE_FILES.revenueAudit
    },
    { 
      id: '4', 
      title: 'AI Prompt Library for Marketers', 
      description: '100 battle-tested prompts for content creation, research, and campaign planning.', 
      category: 'AI & Automation', 
      is_free: false,
      download_url: ''
    },
  ];

  const filtered = filter === 'All' ? resources : resources.filter(r => r.category === filter);

  const handleDownload = (resource) => {
    if (resource.is_free && resource.download_url) {
      // Open lead capture modal for free resources
      setDownloadModal({ open: true, resource });
    }
  };

  return (
    <section id="resources" className="section bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-[#00D4FF]/10 border border-[#00D4FF]/30 rounded-full text-[#00D4FF] text-sm font-medium mb-4">
            The Transmission Hub
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold mb-4 font-display" data-testid="resources-headline">
            Free & Premium <span className="gradient-text">Resources</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Built from real campaigns, real clients, real results. Download what you need — deploy it immediately.
          </p>
        </div>

        {/* Filter pills */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map(cat => (
            <button
              key={cat}
              onClick={() => setFilter(cat)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                filter === cat 
                  ? 'bg-[#A855F7] text-white' 
                  : 'bg-white/5 text-gray-400 hover:text-white hover:bg-white/10'
              }`}
              data-testid={`filter-${cat.toLowerCase().replace(/\s+/g, '-')}`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Resource cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {filtered.map((resource, idx) => (
            <div key={resource.id} className="card group" data-testid={`resource-${idx}`}>
              <div className={`inline-block px-3 py-1 rounded-full text-xs font-medium mb-4 ${
                resource.is_free ? 'bg-green-500/20 text-green-400' : 'bg-[#FF9F43]/20 text-[#FF9F43]'
              }`}>
                {resource.is_free ? 'Free Download' : 'Premium'}
              </div>
              <h4 className="font-bold text-lg mb-2">{resource.title}</h4>
              <p className="text-gray-400 text-sm mb-4">{resource.description}</p>
              <button 
                onClick={() => handleDownload(resource)}
                className="text-sm text-[#00D4FF] group-hover:underline"
                disabled={!resource.is_free && !resource.download_url}
              >
                {resource.is_free ? 'Download Free →' : 'Coming Soon'}
              </button>
            </div>
          ))}
        </div>

        {/* Blog crosslink */}
        <div className="text-center mt-12 pt-12 border-t border-white/10">
          <p className="text-gray-400 mb-4">Want the long-form thinking?</p>
          <Link to="/blog" className="btn-secondary inline-block" data-testid="blog-link">
            Enter the AMV Signal Feed →
          </Link>
        </div>
      </div>

      {/* Resource Download Modal */}
      <ResourceDownloadModal 
        isOpen={downloadModal.open} 
        onClose={() => setDownloadModal({ open: false, resource: null })} 
        resource={downloadModal.resource} 
      />
    </section>
  );
};

// Contact Section
const ContactSection = ({ onEnquire }) => {
  const [formData, setFormData] = useState({
    name: '', email: '', company: '', country: '', budget_range: '', message: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/leads`, { 
        ...formData, 
        source: 'contact_form' 
      });
      if (window.fbq) window.fbq('track', 'Lead', { content_name: 'contact_form' });
      setSuccess(true);
      setFormData({ name: '', email: '', company: '', country: '', budget_range: '', message: '' });
    } catch (err) {
      if (process.env.NODE_ENV === 'development') console.error('Error:', err);
    }
    setLoading(false);
  };

  return (
    <section id="contact" className="section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-4 font-display" data-testid="contact-headline">
            Ready to Scale? <span className="gradient-text">Let's Connect.</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {/* Book a Call */}
          <div className="card flex flex-col h-full">
            <h3 className="text-xl font-bold mb-4 font-display">Book a Call</h3>
            <p className="text-gray-400 mb-6">Schedule your free 30-minute growth audit with our team.</p>
            <div className="flex-grow">
              <div className="rounded-xl overflow-hidden bg-[#111] h-[400px]">
                <iframe
                  src={`${CALENDLY_URL}?hide_gdpr_banner=1&background_color=111111&text_color=ffffff&primary_color=a855f7`}
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  title="Schedule a call"
                  data-testid="calendly-embed"
                />
              </div>
            </div>
            <button 
              onClick={() => { if (window.fbq) window.fbq('track', 'Schedule'); window.open(CALENDLY_URL, '_blank'); }}
              className="btn-primary w-full mt-6"
              data-testid="contact-book-call-btn"
            >
              <span>Open Calendar</span>
            </button>
          </div>

          {/* Send a Transmission */}
          <div className="card flex flex-col h-full">
            <h3 className="text-xl font-bold mb-4 font-display">Send a Transmission</h3>
            <p className="text-gray-400 mb-6">Tell us about your business and goals.</p>
            
            <div className="flex-grow flex flex-col">
              {success ? (
                <div className="text-center py-8 flex-grow flex flex-col justify-center">
                  <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <h4 className="text-lg font-bold mb-2">Message Sent!</h4>
                  <p className="text-gray-400 text-sm">We'll be in touch soon.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-4 flex-grow flex flex-col">
                  <input type="text" placeholder="Your Name" className="form-input" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} required data-testid="contact-name-input" />
                  <input type="email" placeholder="Email" className="form-input" value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} required data-testid="contact-email-input" />
                  <input type="text" placeholder="Company" className="form-input" value={formData.company} onChange={e => setFormData({...formData, company: e.target.value})} required data-testid="contact-company-input" />
                  <input type="text" placeholder="Country" className="form-input" value={formData.country} onChange={e => setFormData({...formData, country: e.target.value})} required data-testid="contact-country-input" />
                  <select className="form-input" value={formData.budget_range} onChange={e => setFormData({...formData, budget_range: e.target.value})} required data-testid="contact-budget-select">
                    <option value="">Budget Range</option>
                    <option value="Under USD 1500">Under USD 1500</option>
                    <option value="USD 1500-3000">USD 1500 - 3000</option>
                    <option value="USD 3000-5000">USD 3000 - 5000</option>
                    <option value="USD 5000+">USD 5000+</option>
                  </select>
                  <textarea placeholder="About Your Business" className="form-input min-h-[80px] flex-grow" value={formData.message} onChange={e => setFormData({...formData, message: e.target.value})} data-testid="contact-message-input" />
                  <button type="submit" className="btn-primary w-full mt-auto" disabled={loading} data-testid="contact-submit-btn">
                    <span>{loading ? 'Sending...' : 'Send Message'}</span>
                  </button>
                </form>
              )}
            </div>
          </div>

          {/* Direct Line */}
          <div className="card flex flex-col h-full">
            <h3 className="text-xl font-bold mb-4 font-display">Direct Line</h3>
            <p className="text-gray-400 mb-6">Prefer a direct conversation? Reach out anytime.</p>
            
            <div className="flex-grow flex flex-col justify-center items-center text-center">
              <div className="space-y-6 w-full">
                <div>
                  <p className="text-gray-500 text-sm mb-1">Email</p>
                  <a href="mailto:connect@abstractmediaverse.com" className="text-[#00D4FF] hover:underline" data-testid="contact-email-link">
                    connect@abstractmediaverse.com
                  </a>
                </div>
                <div>
                  <p className="text-gray-500 text-sm mb-1">Phone</p>
                  <a href="tel:+918108736634" className="text-white hover:text-[#A855F7] transition-colors" data-testid="contact-phone-link">
                    +91 8108736634
                  </a>
                </div>
                <div>
                  <p className="text-gray-500 text-sm mb-1">Phone (US)</p>
                  <a href="tel:+14142463109" className="text-white hover:text-[#A855F7] transition-colors" data-testid="contact-phone-us-link">
                    +1 414 246 3109
                  </a>
                </div>
              </div>
            </div>
              
            <a 
              href={`https://wa.me/${WHATSAPP_NUMBER}?text=Hi%2C%20I%27m%20interested%20in%20learning%20more%20about%20Abstract%20MediaVerse%20services.`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-3 px-6 py-4 bg-[#25D366]/10 border border-[#25D366]/30 rounded-xl hover:bg-[#25D366]/20 transition-all mt-6"
              data-testid="whatsapp-btn"
            >
              <svg className="w-6 h-6 text-[#25D366]" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              <span className="font-medium">Chat on WhatsApp</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

// Footer
const Footer = ({ onOpenLegal }) => {
  return (
    <footer className="py-12 px-6 bg-[#050505] border-t border-white/5">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div className="md:col-span-2">
            <img src={LOGO_WHITE} alt="Abstract MediaVerse" className="h-10 mb-4" />
            <p className="text-gray-400 text-sm max-w-sm">
              Building digital excellence for growth-ready businesses. Your dedicated marketing partner.
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <div className="space-y-2 text-gray-400 text-sm">
              <a href="#about" className="block hover:text-white transition-colors">About</a>
              <a href="#services" className="block hover:text-white transition-colors">Services</a>
              <a href="#clients" className="block hover:text-white transition-colors">Clients</a>
              <Link to="/blog" className="block hover:text-white transition-colors">Blog</Link>
            </div>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Connect</h4>
            <div className="flex gap-3 mb-4">
              <a href={SOCIAL_LINKS.amvLinkedIn} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/5 rounded-lg flex items-center justify-center hover:bg-[#0077B5] transition-colors" title="LinkedIn">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>
              </a>
              <a href={SOCIAL_LINKS.amvInstagram} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/5 rounded-lg flex items-center justify-center hover:bg-gradient-to-br hover:from-[#f09433] hover:via-[#e6683c] hover:to-[#bc1888] transition-colors" title="Instagram">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
              </a>
              <a href={SOCIAL_LINKS.amvFacebook} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/5 rounded-lg flex items-center justify-center hover:bg-[#1877F2] transition-colors" title="Facebook">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg>
              </a>
            </div>
            <a href="tel:+14142463109" className="text-gray-400 text-sm hover:text-white transition-colors" data-testid="footer-phone">
              +1 414 246 3109
            </a>
          </div>
        </div>
        
        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © 2026 Abstract MediaVerse. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-400">
            <button 
              onClick={() => onOpenLegal('privacy')} 
              className="hover:text-white transition-colors"
              data-testid="privacy-policy-link"
            >
              Privacy Policy
            </button>
            <button 
              onClick={() => onOpenLegal('terms')} 
              className="hover:text-white transition-colors"
              data-testid="terms-link"
            >
              Terms of Service
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

// Blog Page
const BlogPage = () => {
  const [posts, setPosts] = useState([]);
  const [filter, setFilter] = useState('All');
  const pillars = ['All', 'Strategy', 'Content', 'Ads', 'AI & Automation', 'Brand'];

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const res = await axios.get(`${API}/blog`);
        setPosts(res.data);
      } catch (err) {
        setPosts([
          { id: '1', title: 'Why Most Marketing Agencies Fail Growth-Stage Businesses', slug: 'why-agencies-fail', pillar: 'Strategy', excerpt: 'The agency model is broken for businesses past survival mode.', read_time: 8, created_at: new Date().toISOString() },
          { id: '2', title: 'The AI Content Workflow We Use for 30-Day Campaigns', slug: 'ai-content-workflow', pillar: 'AI & Automation', excerpt: 'How we turn one brand brief into a full month of content.', read_time: 12, created_at: new Date().toISOString() },
        ]);
      }
    };
    fetchPosts();
  }, []);

  const filtered = filter === 'All' ? posts : posts.filter(p => p.pillar === filter);

  return (
    <div className="min-h-screen bg-[#0D0D0D] pt-24">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl lg:text-5xl font-bold mb-4 font-display" data-testid="blog-headline">
            The AMV <span className="gradient-text">Signal Feed</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Long-form thinking on strategy, content, and growth.
          </p>
        </div>

        {/* Filter pills */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {pillars.map(pillar => (
            <button
              key={pillar}
              onClick={() => setFilter(pillar)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                filter === pillar 
                  ? 'bg-[#A855F7] text-white' 
                  : 'bg-white/5 text-gray-400 hover:text-white hover:bg-white/10'
              }`}
            >
              {pillar}
            </button>
          ))}
        </div>

        {/* Blog posts */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((post, idx) => (
            <article key={post.id} className="card group" data-testid={`blog-post-${idx}`}>
              <span className="inline-block px-3 py-1 bg-[#A855F7]/10 text-[#A855F7] rounded-full text-xs font-medium mb-4">
                {post.pillar}
              </span>
              <h2 className="text-xl font-bold mb-3 group-hover:text-[#00D4FF] transition-colors">
                {post.title}
              </h2>
              <p className="text-gray-400 text-sm mb-4">{post.excerpt}</p>
              <div className="flex items-center justify-between text-sm text-gray-500">
                <span>{post.read_time} min read</span>
                <span>{new Date(post.created_at).toLocaleDateString()}</span>
              </div>
            </article>
          ))}
        </div>

        {filtered.length === 0 && (
          <p className="text-center text-gray-500 py-12">No posts found in this category yet.</p>
        )}
      </div>
    </div>
  );
};

// Home Page
const HomePage = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const { showTimedPopup, showExitPopup, closeTimedPopup, closeExitPopup } = usePopupManager();

  return (
    <>
      <HeroSection />
      <AMVAngleSection />
      <ServicesSection onEnquire={() => setModalOpen(true)} />
      <ClientsSection />
      <FounderSection />
      <ResourcesSection />
      <ContactSection onEnquire={() => setModalOpen(true)} />
      <LeadFormModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
      
      {/* Timed Popup - appears after 20 seconds */}
      {showTimedPopup && <TimedPopup onClose={closeTimedPopup} />}
      
      {/* Exit Intent Popup - appears when mouse leaves viewport */}
      {showExitPopup && <ExitIntentPopup onClose={closeExitPopup} />}
    </>
  );
};

// Main App
function App() {
  const [legalModal, setLegalModal] = useState({ open: false, type: null });

  const openLegal = (type) => setLegalModal({ open: true, type });
  const closeLegal = () => setLegalModal({ open: false, type: null });

  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/*" element={
            <>
              <Navigation />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/blog" element={<BlogPage />} />
              </Routes>
              <Footer onOpenLegal={openLegal} />
              <FloatingWhatsApp />
              <LegalModal isOpen={legalModal.open} onClose={closeLegal} type={legalModal.type} />
            </>
          } />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
